export const DESCRIPTION_TEXT =
  'View documents submitted by company in filing to understand more details about them.';
export const BUTTON_TEXT = 'View red herring document';
